import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import timeInHours from "../../constants/contentFile.json";
import "./reportTimeBox.css";
import DropdownArrow from "../../assets/images/dropdownArrow.svg";

const ReportTimeBox = ({ selectedItem, setSelectedItem, clname }) => {
  const [showDropdownList, setShowDropdownList] = useState(false);

  return (
    <Dropdown className={"drop-item time-drop-down "} align="end">
      <Dropdown.Toggle
        variant="secondary"
        id="dropdown-basic"
        className={"time-box " + clname}
      >
        {selectedItem.name}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-box ">
        {timeInHours?.timeInHours?.map((item, index) => {
          return (
            <Dropdown.Item
              href="#/action-1"
              key={index}
              onClick={(e) => {
                e.preventDefault();
                {
                  console.log(timeInHours);
                }

                setSelectedItem(item), setShowDropdownList(false);
              }}
            >
              {item.name}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ReportTimeBox;
